"use client";

import { createContext, useContext, ReactNode } from 'react';
import { useMarketWatchlist, WatchlistItem } from '@/hooks/useMarketWatchlist';

interface MarketWatchlistContextType {
  watchlist: WatchlistItem[];
  watchlistSlugs: Set<string>;
  loading: boolean;
  error: string | null;
  isInWatchlist: (slug: string) => boolean;
  addToWatchlist: (marketSlug: string, marketTitle?: string, conditionId?: string, source?: string) => Promise<boolean>;
  removeFromWatchlist: (marketSlug: string, source?: string) => Promise<boolean>;
  toggleWatchlist: (marketSlug: string, marketTitle?: string, conditionId?: string, source?: string) => Promise<boolean>;
  refetch: () => Promise<void>;
  hasBookmarks: boolean;
  hasBookmarksForSource: (source: string) => boolean;
}

const MarketWatchlistContext = createContext<MarketWatchlistContextType | null>(null);

export function MarketWatchlistProvider({ children }: { children: ReactNode }) {
  const watchlistState = useMarketWatchlist();

  return (
    <MarketWatchlistContext.Provider value={watchlistState}>
      {children}
    </MarketWatchlistContext.Provider>
  );
}

export function useMarketWatchlistContext() {
  const context = useContext(MarketWatchlistContext);
  if (!context) {
    throw new Error('useMarketWatchlistContext must be used within MarketWatchlistProvider');
  }
  return context;
}

// Optional hook that returns null if outside provider (for optional usage)
export function useMarketWatchlistOptional() {
  return useContext(MarketWatchlistContext);
}
